import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";

const STORAGE_KEY = "fds_import_last_notified_total";
const POLL_MS = 20000;

export const ImportNotifier = () => {
  const { user } = useAuth();
  const { t } = useI18n();
  const wasRunning = useRef(false);

  useEffect(() => {
    if (user?.Role !== "ADMIN") return;
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get("/produits/import-fds-fhd/status");
        if (cancelled) return;
        if (data.running) {
          wasRunning.current = true;
          return;
        }
        const lastNotified = localStorage.getItem(STORAGE_KEY);
        const runKey = `${data.total}-${data.processed}`;
        if ((wasRunning.current || lastNotified === null) && data.total > 0 && lastNotified !== runKey) {
          toast.success(t("cadre.import_fds_termine"), {
            description: t("cadre.import_fds_resume")
              .replace("{produits}", data.created_produits)
              .replace("{dangers}", data.created_dangers)
              .replace("{erreurs}", (data.errors || []).length),
            duration: 12000,
            data: { testid: "toast-fds-import-complete" },
          });
          localStorage.setItem(STORAGE_KEY, runKey);
        }
        wasRunning.current = false;
      } catch {
        // silent - notifier is best-effort
      }
    };

    poll();
    const interval = setInterval(poll, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user, t]);

  return null;
};
